import { useNavigate } from "react-router-dom";
import { FlaskConical, ArrowLeft } from "lucide-react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Persistent banner shown whenever the owner is impersonating the flagged test customer.
export default function TestModeBanner() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  if (!user || user === false || !user.test) return null;

  const exit = async () => {
    try {
      const { data } = await http.post("/owner/stop-impersonate");
      setUser(data);
    } catch (e) {}
    nav("/owner");
  };

  return (
    <div className="sticky top-0 z-[100] bg-[#C49A5A] text-[#2a1e0e]" data-testid="test-mode-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <FlaskConical size={16} /> TEST MODE — CUSTOMER VIEW · NO REAL CUSTOMER DATA
        </div>
        <button data-testid="banner-return-owner" onClick={exit}
          className="flex items-center gap-1.5 text-sm bg-[#2a1e0e] text-[#F7F5F0] rounded-full px-4 py-1.5 hover:bg-black/80 transition-colors">
          <ArrowLeft size={14} /> Return to Owner Dashboard
        </button>
      </div>
    </div>
  );
}
